var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoyow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#21a5de",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.49 16.575c.34.364.546.849.546 1.381 0 1.129-.928 2.044-2.072 2.044-1.143 0-2.07-.915-2.07-2.044 0-.532.206-1.017.544-1.381A.743.743 0 0117.243 16a.72.72 0 01.157-.45c-.369.334-.86.538-1.4.538s-1.031-.204-1.4-.538a.72.72 0 01.157.45c0 .403-.33.73-.74.73a.743.743 0 01-.455-.155c.338.364.545.849.545 1.381 0 1.129-.928 2.044-2.071 2.044-1.144 0-2.072-.915-2.072-2.044 0-.532.207-1.017.545-1.381A.743.743 0 019.314 16a.72.72 0 01.157-.45c-.369.334-.86.538-1.4.538-1.144 0-2.071-.915-2.071-2.044S6.927 12 8.071 12c1.144 0 2.071.915 2.071 2.044a2.02 2.02 0 01-.545 1.381.743.743 0 011.196.575.72.72 0 01-.157.45c.368-.334.86-.538 1.4-.538.54 0 1.03.204 1.4.538a.72.72 0 01-.158-.45.743.743 0 111.196-.575 2.022 2.022 0 01-.545-1.381c0-1.129.927-2.044 2.071-2.044s2.071.915 2.071 2.044a2.02 2.02 0 01-.545 1.381.743.743 0 011.196.575.72.72 0 01-.157.45c.368-.334.86-.538 1.4-.538.54 0 1.03.204 1.4.538a.72.72 0 01-.158-.45.743.743 0 111.196-.575 2.022 2.022 0 01-.545-1.381c0-1.129.927-2.044 2.071-2.044S26 12.915 26 14.044s-.927 2.044-2.071 2.044c-.54 0-1.031-.204-1.4-.538a.72.72 0 01.157.45c0 .403-.33.73-.74.73a.743.743 0 01-.455-.155z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoyow);
export default __webpack_public_path__ + "static/media/yoyow.d75f57e12ca2f0717915a98bfc44d952.svg";
export { ForwardRef as ReactComponent };